import { ValidationKey } from '@/constants/validation-key';
import { maxSameCharacters } from '@/validators/common';
import { ValidationReturn } from '@/validators/countryInstanceValidators';

export function validateName(name: string, minLength = 2): ValidationReturn {
    if (name.length < minLength) return ValidationKey.FieldToShort;
    name = name || '';

    name = name.trim().normalize('NFC');

    const repeatedCharactersValidation = maxSameCharacters(name, minLength);
    const pattern = /^[0-9\p{L}\p{M}]{2}[\p{L}\p{M}\s-]*$/u;
    const isValid = pattern.test(name.toLowerCase()) && !repeatedCharactersValidation;

    return !isValid ? ValidationKey.InvalidFormat : undefined;
}
